<template>
    <div class="py-2 d-flex" style="width: calc(100vw - 56px)">
        <div class="d-flex flex-column flex-grow-1 flex-shrink-1 overflow-hidden">
            <span class="d-flex">
                <v-icon size="small" class="mr-1 d-inline-block" style="margin-top: 1px">{{ serviceTypeIcon }}</v-icon>
                <span class="text-subtitle-2 font-weight-medium" v-html="service.pureTitle" />
            </span>
            <div class="pl-5" v-html="service.title" />
            <div class="pl-5 text--secondary" v-html="service.location" />
            <div class="pl-5 text-no-wrap" v-html="service.date" />
            <span v-if="service.travellers !== '-'" class="mt-2 pl-5" v-html="service.travellers" />
        </div>
        <div class="d-flex flex-column flex-grow-0 flex-shrink-0 align-end overflow-hidden">
            <template v-if="!service.isEmptyOrder">
                <orders-supplier-price-label v-if="isAgency" class="d-flex flex-column align-end" :item="service" />
                <orders-price-label v-else class="d-flex flex-column align-end" :item="service" />
            </template>
            <span class="mb-2" :class="`${service.statusColor}`">{{ service.status }}</span>
            <v-btn
                v-if="isShowVoucherBtn && isVoucherAvailable"
                size="small"
                elevation="0"
                class="cursor-pointer my-1"
                @click="openVoucherDialog"
            >
                {{ $t('voucher') }}
            </v-btn>
            <v-btn
                v-if="!$conf.public.account.hideAddServiceBtn && service.isEmptyOrder"
                :color="'primary'"
                size="small"
                @click="showAddServiceModal"
                v-text="$t('add_service')"
            />
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Emit, Prop, Vue} from 'vue-facing-decorator'
    import {getServiceTypeIcon} from '~src/utils/helpers'
    import OrdersPriceLabel from '@/components/account/snippets/OrdersPriceLabel.vue'
    import OrdersSupplierPriceLabel from '@/components/account/snippets/OrdersSupplierPriceLabel.vue'

    @Component({
        components: {OrdersSupplierPriceLabel, OrdersPriceLabel},
    })
    export class OrdersServiceMobile extends Vue {
        @Prop() service

        @Emit()
        openVoucherDialog() {
            return this.service
        }

        @Emit()
        showAddServiceModal() {
            return this.service.orderId
        }

        get serviceTypeIcon() {
            return getServiceTypeIcon(this.service)
        }

        get isVoucherAvailable() {
            return runtimeStore.isServiceVoucherAvailable(this.service)
        }

        get isAgency() {
            return authStore.isAgency
        }

        get isShowVoucherBtn() {
            return !this.service.isEmptyOrder
        }
    }

    export default OrdersServiceMobile
</script>
